console.log('✅ catalog-subcategory.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState } from '../../js/state.js';
import { getTextTranslationByKey } from '../../js/translator.js';
import {
  getLinksTranslationByKey,
  getLinksTranslationByKeySingleWord,
} from '../../js/router-routes-manager.js';
import {
  saveToLocalStorage,
  loadFromLocalStorage,
  saveToLocalStorageWithLimitAndExpiry,
} from '../../js/utils-local-storage.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { buildComponentCategoryCard } from '../cards/category-card.js';
import { buildComponentBreadcrumb } from '../bread-crumbs/bread-crumb.js';
import {
  isNodeEnvironment,
  myFetchJsonContentFromBuildData,
} from '../../js/utils-fetch-data-json.js';
import { convertStringToInt } from '../../js/utils-convert-numbers.js';

export async function buildComponentCatalogSubcategory(params) {
  console.log(`🔄 Building Component: CatalogSubcategory - lang: ${appState.SiteLanguageCookie}`);

  try {
    let paramsArray = params.split(',');
    let selectedCategoryID = paramsArray[0];
    let selectedSubcategoryID = paramsArray[2];

    //convert selectedSubcategoryID to numnber
    selectedCategoryID = convertStringToInt(selectedCategoryID);
    selectedSubcategoryID = convertStringToInt(selectedSubcategoryID);

    // Fetch  categories
    const selectedCategory = await populateSelectedCategory(selectedCategoryID);
    const selectedSubcategory = await populateSelectedSubcategory(selectedSubcategoryID);

    const selectedCategoryName = selectedCategory.name;
    const selectedCategorySEOPageName = selectedCategory.seoPageName;
    const selectedCategoryLink = `/${appState.SiteLanguageCookie}/${selectedCategory.departmentID}/${selectedCategory.seoPageName}`;

    const selectedSubcategoryName = selectedSubcategory.name;
    const selectedSubcategorySEOPageName = selectedSubcategory.seoPageName;
    const selectedSubcategoryDescriptionAsHtml = selectedSubcategory.description;

    const text1 = await getTextTranslationByKey('keyHome', appState.SiteLanguageCookie);
    const link1 = '/';
    const text2 = selectedCategoryName;
    const link2 = selectedCategoryLink;
    const text3 = selectedSubcategoryName;
    const link3 = '';
    const text4 = '';
    const link4 = '';
    const text5 = '';
    const link5 = '';

    const breadCrumbHtmlSpan = await buildComponentBreadcrumb(
      text1,
      link1,
      text2,
      link2,
      text3,
      link3,
      text4,
      link4,
      text5,
      link5
    );

    const allSubcategories = await populateAllProductsInSubcategory(selectedSubcategoryID);
    const allProductsInSubcategoryHtml = await renderAllProductsInSubcategoryAsHtml(
      selectedCategoryID,
      selectedCategorySEOPageName,
      selectedSubcategoryID,
      selectedSubcategorySEOPageName,
      allSubcategories
    );

    // Build the categories HTML
    const html = `
            <center>
                <div class="myPageMargins">

                  ${breadCrumbHtmlSpan}

                    <h1> ${selectedSubcategoryName}</h1>


                        <div class="AllHomePageCategoryContainer">
                          ${allProductsInSubcategoryHtml}
                         </div>

                         <div class="department-page-description-content">

                         ${selectedSubcategoryDescriptionAsHtml}
                           </div>


                          </div>
                          <div class="safe-footer"></div>
                </center>
                        
                      
        `;

    console.log('✅ CatalogCategories built successfully.');

    // Register event listeners
    //  registerEventListenerToAttach(attachEventListenersCatalogCategories);

    return html;
  } catch (err) {
    console.error('❌ Error building CatalogCategories:', err);
    return '<div>Error loading All categories</div>';
  }
}

async function renderAllProductsInSubcategoryAsHtml(
  selectedCategoryID,
  selectedCategorySEOPageName,
  selectedSubcategoryID,
  selectedSubcategorySEOPageName,
  allProductsInSubcategory
) {
  console.log('🔄 Rendering All categories HTML');

  if (!allProductsInSubcategory || allProductsInSubcategory.length === 0) {
    return `<p>No subcategories available at the moment.</p>`;
  }

  // const singleWordTranslatedForLinksCategory = await getLinksTranslationByKeySingleWord("keyCategory",lang);

  const catgorycards = await Promise.all(
    allProductsInSubcategory.map(async product => {
      const builtLink = `/${appState.SiteLanguageCookie}/${selectedCategoryID}/${selectedCategorySEOPageName}/${selectedSubcategoryID}/${selectedSubcategorySEOPageName}/${product.productID}/${product.seoPageName}`;

      const imageSource = product.image1FileName;
      const name = product.name;
      const categoryCardType = 'Basic';

      return await buildComponentCategoryCard(builtLink, imageSource, name, categoryCardType);
    })
  );

  return catgorycards.join('');
}

/**
 * Attach event listeners to the CatalogCategories component
 */
function attachEventListenersCatalogCategories() {
  try {
    console.log('✅ CatalogCategories event listeners attached.');
    // Placeholder for future event listeners if needed
  } catch (error) {
    console.error('❌ Error attaching event listeners to CatalogCategories:', error);
  }
}

async function populateSelectedCategory(selectedCategoryID) {
  console.log('✅ Populating Selected Category Page');

  const storageKey = `All_Categories_${appState.SiteLanguageCookie}`;

  // Try to load from localStorage first
  const cachedCategories = loadFromLocalStorage(storageKey);
  if (cachedCategories && Array.isArray(cachedCategories) && cachedCategories.length > 0) {
    console.log('✅ Loaded CatalogCategories from cache');

    // select the first category with the selectedCategory
    const selectedCategory = cachedCategories.find(
      category => category.departmentID === selectedCategoryID
    );

    if (selectedCategory) {
      console.log('✅ Loaded selected category from cache');
      return selectedCategory;
    } else {
      console.warn(`⚠️ No selected category found with ID '${selectedCategoryID}' in cache`);
      // Fetch from the server if not cached
      console.log('🌐 Fetching CatalogCategory from server');
      return await fetchSelectedCategory(selectedCategoryID);
    }
  }

  // Fetch from the server if not cached
  console.log('🌐 Fetching CatalogCategory from server');
  return await fetchSelectedCategory(selectedCategoryID);
}

async function populateSelectedSubcategory(selectedSubcategoryID) {
  console.log('✅ Populating Selected Subcategory Page');

  const storageKey = `All_Subcategories_${appState.SiteLanguageCookie}`;

  // Try to load from localStorage first
  const cachedCategories = loadFromLocalStorage(storageKey);
  if (cachedCategories && Array.isArray(cachedCategories) && cachedCategories.length > 0) {
    console.log('✅ Loaded CatalogCategories from cache');

    // select the first category with the selectedSubcategoryID
    const selectedSubcategory = cachedCategories.find(
      category => category.categoryID === selectedSubcategoryID
    );

    if (selectedSubcategory) {
      console.log('✅ Loaded selected category from cache');
      return selectedSubcategory;
    } else {
      console.warn(`⚠️ No selected subcategory found with ID '${selectedSubcategoryID}' in cache`);

      // Fetch from the server if not cached
      console.log('🌐 Fetching CatalogCategory from server');
      return await fetchSelectedSubcategory(selectedSubcategoryID);
    }
  }

  // Fetch from the server if not cached
  console.log('🌐 Fetching CatalogCategory from server');
  return await fetchSelectedSubcategory(selectedSubcategoryID);
}

async function fetchSelectedCategory(selectedSubcategoryID) {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Fetching All products from pre-built data');

      const data = await myFetchJsonContentFromBuildData('categories.json');

      //console.log("Filtered Data:", data);

      if (data && data[lang]) {
        const products = data[lang];
        console.log(
          `✅ Loaded All categories for language '${appState.SiteLanguageCookie}' from pre-built data`
        );

        // select the first category with the selectedSubcategoryID
        const selectedSubcategory = products.find(
          category => category.departmentID === selectedSubcategoryID
        );
        if (selectedSubcategory) {
          console.log('✅ Loaded selected category from pre-built data');
          return selectedSubcategory;
        } else {
          console.warn(
            `⚠️ No selected category found with ID '${selectedSubcategoryID}' in pre-built data`
          );
          return [];
        }
      } else {
        console.warn(`⚠️ No All categories found for language '${appState.SiteLanguageCookie}'`);
        return [];
      }
    } else {
      const storageKey = `All_Categories_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);

      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log('✅ Loaded All categories from cache');
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/GetDepartmentDetailsByIDAsync?departmentID=${selectedSubcategoryID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);

      if (!response.ok) throw new Error('Failed to fetch All categories from server');

      const selectedCategory = await response.json();

      // Save to localStorage
      // Save the selected state with expiry (7 days by default)
      saveToLocalStorageWithLimitAndExpiry(
        storageKey,
        selectedCategory,
        30,
        expiryDuration,
        'departmentID'
      );

      console.log(`🌐 Fetched Category ID ${selectedSubcategoryID} from the server`);
      return selectedCategory;
    }
  } catch (error) {
    console.error('❌ Error fetching home page All categories:', error);
    return [];
  }
}

async function fetchSelectedSubcategory(selectedSubcategoryID) {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Fetching All products from pre-built data');

      const data = await myFetchJsonContentFromBuildData('categories.json');

      //console.log("Filtered Data:", data);

      if (data && data[appState.SiteLanguageCookie]) {
        const products = data[appState.SiteLanguageCookie];
        console.log(
          `✅ Loaded All categories for language '${appState.SiteLanguageCookie}' from pre-built data`
        );

        // select the first category with the selectedSubcategoryID
        const selectedSubcategory = products.find(
          subcategory => subcategory.categoryID === selectedSubcategoryID
        );
        if (selectedSubcategory) {
          console.log('✅ Loaded selected category from pre-built data');
          return selectedSubcategory;
        } else {
          console.warn(
            `⚠️ No selected subcategory found with ID '${selectedSubcategoryID}' in pre-built data`
          );
          return [];
        }
      } else {
        console.warn(`⚠️ No All categories found for language '${appState.SiteLanguageCookie}'`);
        return [];
      }
    } else {
      //const storageKey = `All_Subcategories_${lang}`; //"Subcategories_in_category_${selectedCategoryID}_${lang}"
      //const expiryKey = `${storageKey}_expiry`;
      //const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      //// Check cache first
      //const cached = loadFromLocalStorage(storageKey);
      //const expiryTime = loadFromLocalStorage(expiryKey);

      //if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      //    console.log("✅ Loaded All categories from cache");
      //    return cached;
      //}

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/GetCategoryDetailsByIDAsync?categoryID=${selectedSubcategoryID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);

      if (!response.ok) throw new Error('Failed to fetch All categories from server');

      const selectedSubcategory = await response.json();

      // // Save to localStorage
      // // Save the selected state with expiry (7 days by default)
      // saveToLocalStorageWithLimitAndExpiry(storageKey, selectedSubcategory, 30, expiryDuration, "categoryID");

      console.log(`🌐 Fetched Category ID ${selectedSubcategoryID} from the server`);
      return selectedSubcategory;
    }
  } catch (error) {
    console.error('❌ Error fetching home page All categories:', error);
    return [];
  }
}

async function populateAllProductsInSubcategory(selectedSubcategoryID) {
  console.log(`✅ Populating All Products in Subcategory ${selectedSubcategoryID}`);

  const storageKey = `Products_in_Subcategory_${selectedSubcategoryID}_${appState.SiteLanguageCookie}`;

  // Try to load from localStorage first
  const cachedCategories = loadFromLocalStorage(storageKey);
  if (cachedCategories && Array.isArray(cachedCategories) && cachedCategories.length > 0) {
    console.log('✅ Loaded CatalogSubcategories Producst from cache');
    return cachedCategories;
  }

  // Fetch from the server if not cached
  console.log('🌐 Fetching CatalogSubcategories Producst from server');
  return await fetchAllProductsInSubcatgory(selectedSubcategoryID);
}

async function fetchAllProductsInSubcatgory(selectedSubcategoryID) {
  try {
    if (isNodeEnvironment()) {
      return [];

      console.log('🌐 Fetching All products from pre-built data');

      //const data = await myFetchJsonContentFromBuildData("categories.json");

      ////console.log("Filtered Data:", data);

      //if (data && data[lang]) {
      //    const products = data[lang];
      //    console.log(`✅ Loaded All categories for language '${lang}' from pre-built data`);
      //    return products;
      //} else {
      //    console.warn(`⚠️ No All categories found for language '${lang}'`);
      //    return [];
      //}
    } else {
      const storageKey = `Products_in_Subcategory_${selectedSubcategoryID}_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);

      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(`✅ Loaded All Products for Subcategory ${selectedSubcategoryID} from cache`);
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/GetAllPublishedProductsInCategoryByCategoryIDAsync?categoryID=${selectedSubcategoryID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);

      if (!response.ok)
        throw new Error(
          `Failed to fetch All Subcategories for ${selectedSubcategoryID} from server`
        );

      const allSubcategories = await response.json();

      // Save to localStorage
      saveToLocalStorage(storageKey, allSubcategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(`🌐 Fetched All Subcategories for ${selectedSubcategoryID} from the server`);
      return allSubcategories;
    }
  } catch (error) {
    console.error('❌ Error fetching home page All categories:', error);
    return [];
  }
}

export async function buildComponentCatalogSubcategoryHeaderTags(params) {
  //import { fetchBlogCategoryByCategoryID, fetchGetAllFeaturedArticlesByBlogCategoryIDForBlogCategoryPage, fetchGetAllRecentArticlesByBlogCategoryIDForBlogCategoryPage } from "../../services/data-services/blog-data-service.js";
  // 1. Kick off *all* dynamic imports at once, including your component
  const [{ fetchGetCatalogSubcategorySEOTagsByCategoryID }] = await Promise.all([
    import(
      /* webpackChunkName:"blog-data-service", webpackPrefetch: true */ '../../services/data-services/seo-data-service.js'
    ),
  ]);

  let result = '';

  //get the values from the params
  //const valuesNeeded = params?.split(",") || "";
  //let selectedBlogCategoryID = valuesNeeded[1] || 0;
  //let categorySEOPageName = valuesNeeded[2];

  let paramsArray = params.split(',');
  let selectedCategoryID = paramsArray[0];
  let selectedSubcategoryID = paramsArray[2];

  //convert selectedSubcategoryID to numnber
  selectedCategoryID = convertStringToInt(selectedCategoryID);
  selectedSubcategoryID = convertStringToInt(selectedSubcategoryID);

  // let selectedCategoryID = convertStringToInt(params);

  const currentPageSEOAPIResult = await fetchGetCatalogSubcategorySEOTagsByCategoryID(
    selectedSubcategoryID
  );

  //alert("currentPageSEOAPIResult: " + JSON.stringify(currentPageSEOAPIResult));

  if (!currentPageSEOAPIResult) {
    console.log('❌ Error: seo catalog category not found');

    return result;
  }

  result = currentPageSEOAPIResult;

  return result;
}
